export default "__VITE_ASSET__4ed08a32__"